import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import { getShiftByEmployee } from 'actions/ReportsAction';
import { clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Body from './Body';
import Header from './Header';
import Button from 'screens/components/basic/Button';
import WithRouter from 'custom/withRouter';

class ShiftByEmployee extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0,
            model: {
                pageNumber: 0,
                pageSize: 0,
                beginDate: '',
                endDate: '',
                branchId: 0,
                employeeId: 0
            }
        };

    }
    componentWillMount() {
        this.filter();
        this.cleanSearch();
    }

    resetPagination = (page) => {
        this.setState({ activePage: page ? page : 1 });
    }

    changePage = (e) => {
        this.resetPagination(e);
    }

    getReport = () => {
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let beginDate = this.props.shiftByEmployeeBeginDate ? moment(this.props.shiftByEmployeeBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.shiftByEmployeeEndDate ? moment(this.props.shiftByEmployeeEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = this.props.shiftByEmployeeBranchOption || this.props.loggedBranch;
        let employeeId = this.props.shiftByEmployeeEmployeeNumber;

        this.props.getShiftByEmployee({ pageNumber, pageSize, beginDate, endDate, branchId, employeeId });
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`ShiftByEmployeeBeginDate`);
        this.props.clearFormInput(`ShiftByEmployeeEndDate`);
        this.props.clearFormInput(`ShiftByEmployeeEmployeeNumber`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        const totalRow = this.props.shiftByEmployee.length > 0 ? this.props.shiftByEmployee[0].totalRow : 0;
        const header = (
            <div className="page_header">
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to="/report">{LOOKUP.report.text}</Link></li>
                    <li className="active">{LOOKUP.report.shiftByEmployee.text}</li>
                </ol>
                <h2>
                    {LOOKUP.report.shiftByEmployee.text}
                    <Button type="HeaderBackPage" onTouchTap={() => this.redirectToReport()} />
                </h2>
            </div>
        );
        return (
            <ContainerDivided headerContent={header}>
                <CardSimple>
                    <Header filter={this.filter} />
                    <hr />
                    <Body shiftByEmployee={this.props.shiftByEmployee} />
                </CardSimple>

                <Pagination
                    className="report_pagination"
                    length={totalRow}
                    itemsPerPage={this.state.itemsPerPage}
                    activePage={this.state.activePage}
                    onPageChange={this.changePage}
                />

            </ContainerDivided>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        shiftByEmployee: state.reports.shiftByEmployee,
        loggedBranch: state.common.branchId,
        shiftByEmployeeBeginDate: state.form.ShiftByEmployeeBeginDate,
        shiftByEmployeeEndDate: state.form.ShiftByEmployeeEndDate,
        shiftByEmployeeEmployeeNumber: state.form.ShiftByEmployeeEmployeeNumber,
        shiftByEmployeeBranchOption: state.form.ShiftByEmployeeBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getShiftByEmployee: model => dispatch(getShiftByEmployee(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ShiftByEmployee));